import { logout, setUserToken } from "./reducers/authReducer";
import authService from "./services/authService";
import checkoutService from "./services/checkoutService";
import userOrdersService from "./services/userOrdersService";
import paymentService from "./services/paymentService";
import { clearPendingPayment } from "../utils/pendingPayment";

const customerApiPrefixes = [
  `${authService.reducerPath}/`,
  `${checkoutService.reducerPath}/`,
  `${userOrdersService.reducerPath}/`,
  `${paymentService.reducerPath}/`,
];

const normalizeIdentity = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return String(value);
};

const resetCustomerApiState = (store) => {
  store.dispatch(authService.util.resetApiState());
  store.dispatch(checkoutService.util.resetApiState());
  store.dispatch(userOrdersService.util.resetApiState());
  store.dispatch(paymentService.util.resetApiState());
};

const isCustomerUnauthorizedAction = (action) => {
  if (
    typeof action?.type !== "string" ||
    !action.type.endsWith("/rejected")
  ) {
    return false;
  }

  if (
    !customerApiPrefixes.some((prefix) =>
      action.type.startsWith(prefix)
    )
  ) {
    return false;
  }

  return Number(action?.payload?.status) === 401;
};

const revokeToken = (token) => {
  if (!token || typeof fetch !== "function") {
    return;
  }

  try {
    fetch("/api/user/logout", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "same-origin",
      keepalive: true,
    }).catch(() => {});
  } catch {}
};

const customerSessionMiddleware = (store) => (next) => (action) => {
  const previousState = store.getState();

  const previousToken =
    previousState?.authReducer?.userToken || null;

  const previousUserId = normalizeIdentity(
    previousState?.authReducer?.user?.id
  );

  const result = next(action);

  if (action.type === setUserToken.type) {
    const nextState = store.getState();

    const nextToken =
      nextState?.authReducer?.userToken || null;

    const nextUserId = normalizeIdentity(
      nextState?.authReducer?.user?.id
    );

    const tokenChanged =
      previousToken !== nextToken;

    const identityChanged =
      previousUserId !== nextUserId;

    if (tokenChanged || identityChanged) {
      resetCustomerApiState(store);
    }

    if (
      tokenChanged &&
      previousToken &&
      previousToken !== nextToken
    ) {
      revokeToken(previousToken);
    }

    if (identityChanged) {
      clearPendingPayment();
    }
  }

  if (
    action.type === logout.type &&
    action.payload === "userToken"
  ) {
    clearPendingPayment();
    resetCustomerApiState(store);

    try {
      sessionStorage.removeItem("redirectAfterLogin");
    } catch {}

    revokeToken(previousToken);
  }

  if (
    isCustomerUnauthorizedAction(action) &&
    store.getState()?.authReducer?.userToken
  ) {
    store.dispatch(logout("userToken"));
  }

  return result;
};

export default customerSessionMiddleware;
